module.exports = __webpack_public_path__ + "static/img/25.9e4a326.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/25.png
// module id = ISqb
// module chunks = 0